import styled, { keyframes } from "styled-components";
import { theme } from "../../styles/theme";

const warnPulse = keyframes`
   0%, 100% { opacity: 0.5; transform: scale(1); }
   50% { opacity: 1; transform: scale(1.015); }
`;

const issueFocusPulse = keyframes`
   0%, 100% {
      box-shadow:
         0 0 0 3px var(--issue-focus-ring-soft),
         0 0 0 7px var(--issue-focus-ring),
         ${theme.shadows.float};
   }
   50% {
      box-shadow:
         0 0 0 4px var(--issue-focus-ring-soft),
         0 0 0 10px var(--issue-focus-ring),
         ${theme.shadows.float};
   }
`;

export const Main = styled.div<{ $isMinimize: boolean }>`
   position: relative;
   background: #FFFFFF;
   border: 1.5px solid ${theme.colors.border};
   box-shadow: ${theme.shadows.float};
   border-radius: 16px;
   overflow: visible;
   transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;

   &.issue-focus {
      z-index: 5;
      box-shadow:
         0 0 0 3px var(--issue-focus-ring-soft),
         0 0 0 7px var(--issue-focus-ring),
         ${theme.shadows.float};
      animation: ${issueFocusPulse} 1.4s ease-in-out 2;
   }

   &.issue-focus-error {
      --issue-focus-ring: rgba(185, 28, 28, 0.45);
      --issue-focus-ring-soft: rgba(239, 68, 68, 0.18);
      border-color: #ef4444;
   }

   &.issue-focus-warning {
      --issue-focus-ring: rgba(194, 65, 12, 0.4);
      --issue-focus-ring-soft: rgba(251, 146, 60, 0.2);
      border-color: #f59e0b;
   }
   ${({ $isMinimize }) => $isMinimize ? `
      width: 120px;
      min-width: 120px;
      height: 72px;
      overflow: visible;
   ` : `
      min-width: 150px;
   `}

   &:hover {
      ${({ $isMinimize }) => $isMinimize ? `
         transform: translateY(-3px);
         box-shadow: 0 4px 8px rgba(29, 20, 70, 0.08), 0 20px 34px -14px rgba(29, 20, 70, 0.24);
      ` : ''}
   }

   #subAgent{
      position: absolute;
      left: 43px;
      top: 7px;
      color: ${theme.colors.primary};
      z-index: 1;
      font-family: monospace;
      font-size: 15px;
   }

   #warning {
      position: absolute;
      inset: -3px;
      border: 1.5px solid rgba(226, 96, 74, 0.45);
      border-radius: 19px;
      width: auto;
      height: auto;
      z-index: -1;
      pointer-events: none;
      animation: ${warnPulse} 2s ease-in-out infinite;
      box-shadow: 0 0 0 3px rgba(226, 96, 74, 0.1);
   }
   #warningIcon {
      position: absolute;
      left: 9px;
      top: 8px;
      color: ${theme.colors.coral};
      z-index: 2;
   }
   #ran{
      position: absolute;
      top: -1px;
      left: -1px;
      border: 1.5px solid ${theme.colors.green};
      border-radius: 17px;
      width: calc(100% + 2px);
      height: calc(100% + 2px);
      z-index: -1;
   }
   #ranIcon{
      position: absolute;
      left: 9px;
      top: 8px;
      color: ${theme.colors.green};
      z-index: 2;
   }

   .validationIssueBadge{
      position: absolute;
      top: 15px;
      left: 39px;
      transform: none;
      width: 10px;
      height: 10px;
      border-radius: 0;
      display: grid;
      place-items: center;
      z-index: 7;
      pointer-events: none;
      color: #ef4444;
      background: transparent;
      border: 0;
      box-shadow: none;
      backdrop-filter: none;
      filter: drop-shadow(0 8px 18px rgba(239, 68, 68, 0.22));
      transform: scale(1);
   }

   .validationIssueBadge.warning{
      color: #f59e0b;
      filter: drop-shadow(0 8px 18px rgba(245, 158, 11, 0.22));
   }
   &.execution-error #ran {
      border-color: #ef4444;
      box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.25);
   }
   &.execution-error #ranIcon {
      color: #ef4444;
   }
   &.anthropic .mainTitle .otherSvg {  
      width: 20px;
      height: 20px;
   }

   .mainTitle {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 0;
       padding: ${({ $isMinimize }) => $isMinimize ? '8px' : '30px 30px 15px'};
      height: ${({ $isMinimize }) => $isMinimize ? '72px' : 'auto'};
      box-sizing: border-box;
      background-color: #FFFFFF;
      border-radius: ${({ $isMinimize }) => $isMinimize ? '16px' : '16px 16px 0 0'};

      > div:first-of-type {
         display: flex;
         align-items: center;
         justify-content: center;
         flex: ${({ $isMinimize }) => $isMinimize ? '0 0 48px' : '0 0 auto'};
         flex-shrink: 0;
         width: ${({ $isMinimize }) => $isMinimize ? '48px' : '40px'};
         height: ${({ $isMinimize }) => $isMinimize ? '48px' : '40px'};
         border-radius: ${({ $isMinimize }) => $isMinimize ? '13px' : '10px'};
         margin-right: ${({ $isMinimize }) => $isMinimize ? '0' : '15px'};
         box-shadow: ${({ $isMinimize }) => $isMinimize
            ? '0 1px 0 rgba(255, 255, 255, 0.3) inset, 0 -3px 6px rgba(0, 0, 0, 0.14) inset, 0 8px 16px -6px rgba(0, 0, 0, 0.35)'
            : 'none'};

         svg {
            color: #fff;
            font-size: ${({ $isMinimize }) => $isMinimize ? '20px' : '20px'};
         }
         img {
            width: ${({ $isMinimize }) => $isMinimize ? '24px' : '32px'} !important;
            height: ${({ $isMinimize }) => $isMinimize ? '24px' : '32px'} !important;
            object-fit: contain;
         }
         .otherSvg {
            ${({ $isMinimize }) => $isMinimize ? `
               width: 24px;
               height: 24px;
            ` : `
               width: 20px;
               height: 20px;
            `};
            svg {
               fill: #fff;
               path { fill: #fff; }
            }
         }
      }

      > .nMeta {
         h5 {
            font-size: 16px;
            font-weight: 500;
         }
         > div {
            display: flex;
            align-items: center;
         }
         .index {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-top: 5px;
            font-size: 15px;
            font-weight: 500;
            z-index: 1;
            padding: 5px 10px;

            > span:first-of-type {
               position: absolute;
               width: 100%;
               height: 100%;
               z-index: -1;
               opacity: 0.18;
               border-radius: 25px;
            }
         }
         .remove {
            display: flex;
            align-items: center;
            margin-left: 5px;
            cursor: pointer;
            transition: all .2s ease-in-out;
            padding: 0 5px;
            opacity: 0.4;

            &:hover {
               opacity: 1;
               color: #F05454;
            }
         }
      }

      /* Grows between equal-width icon + actions columns; centers the divider. */
      .nodeMid {
         flex: 1 1 auto;
         min-width: 12px;
         align-self: stretch;
         display: flex;
         align-items: center;
         justify-content: center;
         pointer-events: none;
      }

      .nodeDivider {
         width: 1px;
         height: 44px;
         border-radius: 999px;
         background: linear-gradient(
            180deg,
            rgba(230, 226, 246, 0) 0%,
            rgba(199, 191, 232, 0.95) 18%,
            rgba(129, 114, 255, 0.55) 50%,
            rgba(199, 191, 232, 0.95) 82%,
            rgba(230, 226, 246, 0) 100%
         );
         box-shadow: 0 0 0 0.5px rgba(255, 255, 255, 0.65);
         pointer-events: none;
      }

      .settings {
         display: flex;
         flex-direction: column;
         flex-wrap: nowrap;
         align-items: center;
         justify-content: center;
         gap: ${({ $isMinimize }) => $isMinimize ? '2px' : '10px'};
         ${({ $isMinimize }) => $isMinimize ? `
            position: relative;
            top: auto;
            right: auto;
            left: auto;
            /* Same column width as the icon so the divider lands dead-center. */
            flex: 0 0 48px;
            width: 48px;
            margin-left: 0;
            padding: 0;
            opacity: 1;
            pointer-events: auto;
         ` : `
            position: absolute;
            top: 18px;
            right: 16px;
            left: auto;
            opacity: 1;

            &::before {
               content: '';
               position: absolute;
               left: -12px;
               top: 50%;
               transform: translateY(-50%);
               width: 1px;
               height: calc(100% + 8px);
               border-radius: 999px;
               background: linear-gradient(
                  180deg,
                  rgba(230, 226, 246, 0) 0%,
                  rgba(199, 191, 232, 0.95) 18%,
                  rgba(129, 114, 255, 0.55) 50%,
                  rgba(199, 191, 232, 0.95) 82%,
                  rgba(230, 226, 246, 0) 100%
               );
               box-shadow: 0 0 0 0.5px rgba(255, 255, 255, 0.65);
               pointer-events: none;
            }
         `}
         cursor: pointer;
         transition: opacity 0.15s ease;
         z-index: 5;

         span, button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: ${({ $isMinimize }) => $isMinimize ? '26px' : 'auto'};
            height: ${({ $isMinimize }) => $isMinimize ? '26px' : 'auto'};
            border-radius: ${({ $isMinimize }) => $isMinimize ? '8px' : '7px'};
            color: #6B6584;
            transition: background-color 0.15s ease, color 0.15s ease;
            background: transparent;
            border: none;
            box-shadow: none;
            padding: 0;
            cursor: pointer;
            flex-shrink: 0;

            svg {
               width: ${({ $isMinimize }) => $isMinimize ? '13px' : '18px'};
               height: ${({ $isMinimize }) => $isMinimize ? '13px' : '18px'};
            }
            &:hover {
               background: ${theme.surface.hoverFill};
               color: ${theme.colors.text};
               opacity: 1;
            }
            &.del:hover,
            &[title="Delete"]:hover {
               background: #FDECEC;
               color: ${theme.colors.coral};
            }
         }

         &.compact {
            gap: 1px;
            padding: 0;

            span, button {
               width: ${({ $isMinimize }) => $isMinimize ? '20px' : 'auto'};
               height: ${({ $isMinimize }) => $isMinimize ? '20px' : 'auto'};
               border-radius: ${({ $isMinimize }) => $isMinimize ? '6px' : '7px'};

               svg {
                  width: ${({ $isMinimize }) => $isMinimize ? '11px' : '16px'};
                  height: ${({ $isMinimize }) => $isMinimize ? '11px' : '16px'};
               }
            }
         }
      }
   }

   &:hover .mainTitle .settings {
      opacity: 1;
   }

   .content {
      background-color: #FFFFFF;
      padding: ${({ $isMinimize }) => $isMinimize ? '0' : '20px'};
      padding-top: ${({ $isMinimize }) => $isMinimize ? '0' : '0'};
      min-width: ${({ $isMinimize }) => $isMinimize ? '0' : '80px'};
      min-height: ${({ $isMinimize }) => $isMinimize ? '0' : '30px'};
      height: ${({ $isMinimize }) => $isMinimize ? '0' : 'auto'};
      overflow: ${({ $isMinimize }) => $isMinimize ? 'hidden' : 'visible'};
      opacity: ${({ $isMinimize }) => $isMinimize ? '0' : '1'};
      pointer-events: ${({ $isMinimize }) => $isMinimize ? 'none' : 'auto'};
      border-radius: 0 0 16px 16px;
   }
   .agentChat{
      margin-top: 5px;
   }
`;
